import { SocialLinks } from "@/components/SocialLinks";

export function Footer() {
  return (
    /* pb-28 ensures content isn't hidden behind the fixed floating dock (~80px) */
    <footer className="bg-background pt-6 md:pt-8 pb-28 px-4 sm:px-6">
      <div className="site-frame flex flex-col items-center gap-6 text-center">
        <SocialLinks only={["GitHub", "LinkedIn", "X", "Gmail"]} className="justify-center" />
        <p className="text-xs text-muted-foreground font-mono">
          © {new Date().getFullYear()} Chirag Gadhvi
        </p>
      </div>
    </footer>
  );
}
